<template>
  <div style="position: relative;">
    <gtable-crud
      ref="gtable-crud"
      :data="data"
      :search-form="searchQuery"
      :option="option"
      :page="page"
      :loading="loading"
      @onPageChange="onPageChange"
      @searchChange="searchChange"
      @searchReset="searchReset"
      @pageChange="pageChange"
      @pageSizeChange="pageSizeChange"
      @upload="upload"
      @rowDel="rowDel"
      @refresh-change="refreshChange"
    >
      <!-- 自定义列 -->
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field == 'enName'">
          <div
            class="en-name-box"
            @click="
              handleImgClick(props.row.attach ? props.row.attach.link : '')
            "
          >
            <b-avatar :src="props.row.attach ? props.row.attach.link : ''" />
            <span>
              <p>{{ props.row.staffNo }}</p>
              <p>{{ props.row.enName }}</p>
            </span>
          </div>
        </span>
        <span v-else-if="props.column.field === 'statusName'">
          <template v-if="props.row.status === 1">
            <div
              v-b-popover.hover.top="props.row.statusName"
              class="status-tag bg-gradient-success"
            />
          </template>
          <template v-else-if="props.row.status === 0">
            <div
              v-b-popover.hover.top="props.row.statusName"
              class="status-tag bg-gradient-warning"
            />
          </template>
          <template v-else>
            <div
              v-b-popover.hover.top="props.row.statusName"
              class="status-tag bg-gradient-secondary"
            />
          </template>
        </span>
        <span v-else-if="props.column.field == 'projectName'">
          <template v-if="props.row.projectName">
            <b-badge
              v-for="item in props.row.projectAbbreviation.split(',')"
              :key="item"
              v-b-popover.hover.top="props.row.projectName"
              variant="light-primary"
              style="margin: 0.2rem"
              >{{ item }}</b-badge
            >
          </template>
        </span>
        <span v-else-if="props.column.field == 'autograph'">
          <template v-if="props.row.autographAttach">
            <b-img
              v-if="props.row.autographAttach.link"
              height="44"
              :src="props.row.autographAttach.link"
              @click="handleImgClick(props.row.autographAttach.link)"
            />
          </template>
        </span>
        <span v-else-if="props.column.field == 'wpExpiryDate'">
          <span :class="{ red: isExpiringDate(props.row.wpExpiryDate) }">
            {{ props.row.wpExpiryDate }}
          </span>
        </span>
      </template>

      <template slot="headMenuLeft">
        <my-tooltip :tooltip="$t('_components.btns.add')">
          <b-button
            variant="primary"
            class="btn ml-0-5 mr-0-5"
            size="sm"
            @click="handleFormOpen('add')"
          >
            <feather-icon icon="PlusIcon" size="18" />
          </b-button>
        </my-tooltip>
        <my-tooltip tooltip="Download project excel">
          <b-button
            :disabled="downloading"
            variant="success"
            class="btn ml-0-5 mr-0-5"
            size="sm"
            @click="handleDownloadProject"
          >
            <feather-icon icon="DownloadCloudIcon" size="18" />
          </b-button>
        </my-tooltip>
        <my-tooltip :tooltip="$t('_components.btns.download')">
          <b-button
            :disabled="downloading"
            variant="success"
            class="btn ml-0-5 mr-0-5"
            size="sm"
            @click="handleDownload"
          >
            <feather-icon icon="DownloadIcon" size="18" />
          </b-button>
        </my-tooltip>
        <my-tooltip :tooltip="$t('_components.btns.upload')">
          <a-upload
            name="excel"
            :show-upload-list="false"
            :custom-request="handleUpLoad"
            :disabled="uploading"
          >
            <div>
              <b-button variant="warning" class="btn ml-0-5 mr-0-5" size="sm">
                <feather-icon icon="UploadIcon" size="18" />
              </b-button>
            </div>
          </a-upload>
        </my-tooltip>
      </template>
      <template slot="menuLeft" slot-scope="{ row }">
        <my-tooltip :tooltip="$t('_components.btns.view')">
          <feather-icon
            icon="SearchIcon"
            class="text-primary cursor-pointer mr-1"
            size="20"
            @click="handleFormOpen('view', row)"
          />
        </my-tooltip>
        <my-tooltip :tooltip="$t('_components.btns.edit')">
          <feather-icon
            icon="Edit2Icon"
            class="text-warning cursor-pointer"
            size="20"
            @click="handleFormOpen('edit', row)"
          />
        </my-tooltip>
      </template>
      <!-- menu自定义示例 在...里面按钮 -->
      <template slot="menuOther" slot-scope="{ row }">
        <!-- 修改账号 -->
        <div
          v-if="permission['staff-info-editAccount']"
          class="btn p-1 ml-0-5"
          @click="handleEditAccount(row)"
        >
          {{ $t('_components.btns.editAccount') }}
        </div>
        <!-- 重置密码 -->
        <div
          v-if="permission['staff-info-resetPassword']"
          class="btn p-1 ml-0-5"
          @click="handleResetPassword(row)"
        >
          {{ $t('_components.btns.resetPassword') }}
        </div>
        <!-- 离职 -->
        <div
          v-if="row.status != 2"
          class="btn p-1 ml-0-5"
          @click="handleStaffQuit(row)"
        >
          {{ $t('_components.btns.staffQuit') }}
        </div>
        <!-- 复职 -->
        <div
          v-if="row.status == 2"
          class="btn p-1 ml-0-5"
          @click="handleStaffJoin(row)"
        >
          {{ $t('_components.btns.staffJoin') }}
        </div>
        <!-- 转正 -->
        <div
          v-if="row.status == 0"
          class="btn p-1 ml-0-5"
          @click="handleStaffConfirmation(row)"
        >
          {{ $t('_components.btns.staffConfirmation') }}
        </div>
        <div
          class="btn p-1 ml-0-5"
          @click="handleVcardLink(row)"
        >
          {{ $t('_components.btns.vcardLink') }}
        </div>
      </template>
    </gtable-crud>

    <c-drawer v-model="drawerVisible" :before-close="handleBeforeClose">
      <component
        :is="formVisibleType"
        v-if="drawerVisible"
        :id="rowDataId"
        :default-form="searchQuery"
        :disabled="drawerDisabled"
        @close="handleDrawerClose"
      />
    </c-drawer>

    <c-modal
      :header="false"
      :footer="false"
      :visible="dialogShow"
      @close="dialogShow = false"
    >
      <template slot="content">
        <div style="text-align: center;">
          <b-img :src="currentImg" fluid alt="Fluid image')" />
        </div>
      </template>
    </c-modal>

    <c-form
      :visible="accountDrawerShow"
      :data="rowData"
      :option="accountOption"
      @beforeClose="
        () => {
          accountDrawerShow = false
        }
      "
      @submit="handleAccountEdit"
    />

    <c-modal
      title="Reset password"
      :visible="resetPasswordShow"
      @close="resetPasswordShow = false"
      @modelConfirm="handleResetPasswordConfirm"
    >
      <template slot="content">
        {{ $t('_components.message.resetPassword') }}
      </template>
    </c-modal>

    <c-modal
      title="Leave office"
      :visible="staffQuitShow"
      @close="staffQuitShow = false"
      @modelConfirm="handleStaffQuitConfirm"
    >
      <template slot="content">
        {{ $t('_components.message.staffQuit') }}
      </template>
    </c-modal>

    <c-modal
      title="Leave office"
      :visible="staffJoinShow"
      @close="staffJoinShow = false"
      @modelConfirm="handleStaffJoinConfirm"
    >
      <template slot="content">
        {{ $t('_components.message.staffJoin') }}
      </template>
    </c-modal>

    <c-modal
      title="Confirmation"
      :visible="staffConfirmationShow"
      @close="staffConfirmationShow = false"
      @modelConfirm="handleStaffConfirmationConfirm"
    >
      <template slot="content">
        {{ $t('_components.message.staffConfirmation') }}
      </template>
    </c-modal>

    <c-modal
      :title="$t('_components.btns.vcardLink')"
      :footer="false"
      :visible="vcardLinkShow"
      @close="vcardLinkShow = false"
    >
      <template slot="content">
        <div class="vcard-link-box">
          <p ref="vcardLinkText">{{ vcardLink }}</p>
          <b-button
            variant="primary"
            size="sm"
            @click="copyVcardLink"
          >
            {{ $t('_components.btns.copy') }}
          </b-button>
        </div>
      </template>
    </c-modal>
  </div>
</template>

<script>
import { staff } from '@/api/staff/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { BButton, BAvatar, BBadge, BImg, VBPopover } from 'bootstrap-vue'
import MyTooltip from '@/components/myTooltip.vue'
import CDrawer from '@/components/drawer.vue'
import CModal from '@/components/crud/modal.vue'
import { deepClone } from '@/util/util'
import { buildVcardLink } from '@/util/vcardLink'
import Ripple from 'vue-ripple-directive'
import {
  getUser,
  update as accountUpdate,
  resetPassword,
} from '@/api/system/user'
import CForm from '@/components/crud/form.vue'
import { mapGetters } from 'vuex'
import StaffFormedit from './components/formEdit.vue'
import StaffFormadd from './components/formAdd.vue'

export default {
  name: 'MyComponent',
  components: {
    BButton,
    MyTooltip,
    StaffFormedit,
    StaffFormadd,
    CDrawer,
    BAvatar,
    BBadge,
    BImg,
    CModal,
    CForm,
  },
  directives: {
    'b-popover': VBPopover,
    Ripple,
  },
  props: {
    searchQuery: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      query: {},
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      data: [],
      loading: false,
      drawerVisible: false,
      formVisibleType: '',
      rowDataId: '',
      rowData: {},
      downloading: false,
      uploading: false,
      dialogShow: false,
      currentImg: '',
      drawerDisabled: false,
      accountDrawerShow: false,
      resetPasswordShow: false,
      staffConfirmation: false,
      staffQuitShow: false,
      staffJoinShow: false,
      staffConfirmationShow: false,
      vcardLinkShow: false,
      vcardLink: '',
    }
  },
  computed: {
    ...mapGetters(['permission']),
    option() {
      const columnsTemp = [
        {
          label: this.i18n('label.enName'),
          field: 'enName',
          search: true,
          searchBase: true,
          width: '450px',
        },
        {
          label: this.i18n('label.cnName'),
          field: 'cnName',
          searchSpan: 2,
          hide: true,
        },
        {
          label: this.i18n('labelEmployment.staffNo'),
          field: 'staffNo',
          hide: true,
          columnHide: true,
          search: true,
          searchBase: true,
        },
        {
          label: this.i18n('labelEmployment.status'),
          field: 'status',
          type: 'select',
          html: true,
          dictField: 'statusName',
          search: true,
          searchBase: true,
          dictBizCode: 'staff_status',
        },
        // {
        //   label: this.i18n('label.account'),
        //   field: 'account',
        //   hide: true,
        // },
        {
          label: this.i18n('labelEmployment.companyId'),
          field: 'companyId',
          dictField: 'signCompanyName',
          type: 'select',
          dictCode: 'company',
          search: true,
        },
        {
          label: this.i18n('labelEmployment.deptId'),
          field: 'deptId',
          dictField: 'deptName',
          type: 'select',
          dictCode: 'dept',
          search: true,
        },
        {
          label: this.i18n('labelEmployment.postId'),
          field: 'postId',
          dictField: 'postName',
          type: 'select',
          dictCode: 'post',
          search: true,
        },
        {
          label: this.i18n('label.project'),
          field: 'projectId',
          dictField: 'projectName',
          type: 'select',
          dictCode: 'project',
          search: true,
        },
        {
          label: this.i18n('label.nationality'),
          field: 'nationality',
          type: 'select',
          dictCode: 'nationality',
          search: true,
          hide: true,
        },
        {
          label: this.i18n('label.sex'),
          field: 'sex',
          dictField: 'sexName',
          hide: true,
          search: true,
          type: 'select',
          dictBizCode: 'gender',
        },
        {
          label: this.i18n('label.birthday'),
          field: 'birthday',
          type: 'dateTime',
          dateInputFormat: 'yyyy-MM-dd hh:mm:ss',
          dateOutputFormat: 'MMM do yy',
          hide: true,
        },
        {
          label: this.i18n('label.nric'),
          field: 'nric',
          hide: true,
          search: true,
          searchBase: true,
        },
        {
          label: this.i18n('label.birthday'),
          field: 'birthdayRinge',
          type: 'dateRange',
          hide: true,
          search: true,
        },
        {
          label: this.i18n('labelEmployment.wpNumber'),
          field: 'wpNumber',
          hide: true,
          search: true,
        },
        {
          label: this.i18n('labelEmployment.wpExpiryDate'),
          field: 'wpExpiryDate',
          type: 'dateRange',
          search: true,
          width: '140px',
        },
        {
          label: this.i18n('labelEmployment.contractPeriodDate'),
          field: 'contractPeriodDateRinge',
          type: 'dateRange',
          hide: true,
          search: true,
        },
        {
          label: this.i18n('labelEmployment.chinaCode'),
          field: 'chinaCode',
          fieldDict: 'chinaCodeName',
          type: 'select',
          dictBizCode: 'china_code',
          search: true,
          hide: true,
        },
        {
          label: 'UEN',
          field: 'signCompanyId',
          type: 'select',
          fieldDict: 'signCompanyName',
          dictCode: 'uenCompany',
          search: true,
          hide: true,
        },
        {
          label: 'Category',
          field: 'category',
          fieldDict: 'categoryName',
          type: 'select',
          dictBizCode: 'staff_category',
          search: true,
          hide: true,
        },
        {
          label: this.i18n('label.mobile'),
          field: 'mobile',
          hide: true,
        },
        {
          label: this.i18n('label.email'),
          field: 'email',
          hide: true,
        },
        {
          label: this.i18n('label.postcode'),
          field: 'postcode',
          hide: true,
        },
        {
          label: this.i18n('label.passportNumber'),
          field: 'passportNumber',
          hide: true,
        },
        {
          label: this.i18n('label.passportExpiryDate'),
          field: 'passportExpiryDate',
          hide: true,
        },
        {
          label: this.i18n('label.passportIssuancePlace'),
          field: 'passportIssuancePlace',
          hide: true,
        },
        {
          label: this.i18n('label.highestEducation'),
          field: 'highestEducation',
          dictField: 'highestEducationName',
          hide: true,
        },
        {
          label: this.i18n('label.address'),
          field: 'address',
          hide: true,
        },
        {
          label: this.i18n('label.photo'),
          field: 'photo',
          hide: true,
        },
        {
          label: this.i18n('label.autograph'),
          field: 'autograph',
          hide: true,
        },
      ]
      const columns = []
      columnsTemp.forEach((item) => {
        const params = item
        const searchObj = this.searchQuery
          ? this.searchQuery[item.field]
          : undefined
        if (searchObj) {
          params.searchDisabled = true
        }
        columns.push(params)
      })
      const option = {
        header: true, // 显示顶部功能区(默认 true)

        addBtn: false, // 新增按钮(默认 true)
        viewBtn: false, // 显示按钮(默认 true)
        editBtn: false, // 修改按钮(默认 true)
        delBtn: true, // 删除按钮(默认 true)
        batchDelBtn: false, // 批量删除按钮(默认 false)
        uploadBtn: false, // 上传按钮(默认 false)
        downloadBtn: false, // 下载按钮(默认 false)

        search: true, // 显示搜索(默认 true)
        isEnterSearch: true,
        menu: true, // 显示菜单(默认 true)
        menuWidth: 200, // 默认200
        form: true, // 是否使用自带form (默认true)
        // drawerWidth: 500, // 默认auto
        searchVisible: false, // 搜索默认展开(默认 false)
        fixedHeader: false, // 固定表头(默认 true)
        lineNumbers: false, // 显示每行数据的下标(默认 false)
        selection: false, // 复选框(默认 false)
        searchSpan: 4, // 自定义搜索栅格(默认 4)

        columns,
      }
      return option
    },
    accountOption() {
      const option = {
        columns: [
          // 列的其他配置可参考vue-good-table
          {
            label: this.$t('system.user.name'),
            field: 'name',
            formOption: {
              // 表单配置
              rules: 'required', // 规则参考vee-validate文档
            },
          },
          {
            label: this.$t('system.user.realName'),
            field: 'realName',
            searchBase: true, // 不需要隐藏显示在上面
            formOption: {
              // 表单配置
              type: 'text', // 列类型
              rules: 'required', // 规则参考vee-validate文档
            },
          },
          {
            label: this.$t('system.user.roleId'),
            field: 'roleId',
            formOption: {
              type: 'check', // 表单类型:select, check
              dictCode: 'baseRole', // 表单字典来源
              rules: 'required', // 规则参考vee-validate文档
            },
          },
          {
            label: this.$t('system.user.phone'),
            field: 'phone',
          },
          {
            label: this.$t('system.user.email'),
            field: 'email',
            formOption: {
              // 表单配置
              type: 'email', // 列类型
              rules: 'email', // 规则参考vee-validate文档
            },
          },
          {
            label: this.$t('system.user.deptName'),
            field: 'deptId',
            formOption: {
              // 表单配置
              type: 'select', // 列类型
              dictCode: 'dept',
              rules: 'required', // 规则参考vee-validate文档
            },
          },
        ],
      }
      return option
    },
  },
  mounted() {
    this.onLoad(this.page)
  },
  methods: {
    async onLoad(page, params = {}) {
      this.loading = true
      const res = await staff.getList(
        page.currentPage,
        page.pageSize,
        Object.assign(params, this.query, this.searchQuery)
      )
      const { data } = res.data
      this.page.total = data.total
      this.data = data.records
      this.loading = false
    },
    // 搜索按钮被点击
    async searchChange(done, e) {
      const temp = deepClone(e)
      const cols = this.option.columns
      Object.keys(temp).forEach((key) => {
        const item = temp[key]
        const col = cols.find((o) => o.field === key) || {}
        const colTypeIsRange = col.type === 'dateRange'
        if (colTypeIsRange) {
          const keyStart = key.replace(/Ringe/, 'Start')
          const keyEnd = key.replace(/Ringe/, 'End')
          if (Array.isArray(item)) {
            const [start, end] = item
            temp[keyStart] = start
            temp[keyEnd] = end
            delete temp[key]
          }
        }
      })
      this.query = temp
      this.page.currentPage = 1
      await this.onLoad(this.page, temp)
      done()
    },
    // 搜索重置
    searchReset() {
      this.query = {}
      this.onLoad(this.page)
    },
    handleDownloadProject() {
      this.downloading = true
      staff.staffProjectExcel().then((res) => {
        // 创建URL对象 URL.createObjectURL(object)
        const url = window.URL.createObjectURL(res.data)
        const link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        // 指定文件名&文件类型(后缀名)
        /**
         * 添加属性,并赋指定的值 el.setAttribute('download','zzz')
         * demo: <a href="abc.gif" download="zzz">
         * download属性的值即使当前要导出的文件的文件名
         * */
        link.setAttribute('download', 'STAFF Project.xlsx')
        link.click()
        // 释放创建的对象(创建的新的URL必须通过该方法释放)
        window.URL.revokeObjectURL(url)
        this.downloading = false
      })
    },
    // 点击下载按钮
    handleDownload(e) {
      this.downloading = true
      staff.exportExcel(Object.assign(this.query, this.searchQuery)).then((res) => {
        // 创建URL对象 URL.createObjectURL(object)
        const url = window.URL.createObjectURL(res.data)
        const link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        // 指定文件名&文件类型(后缀名)
        /**
         * 添加属性,并赋指定的值 el.setAttribute('download','zzz')
         * demo: <a href="abc.gif" download="zzz">
         * download属性的值即使当前要导出的文件的文件名
         * */
        link.setAttribute('download', 'STAFF.xlsx')
        link.click()
        // 释放创建的对象(创建的新的URL必须通过该方法释放)
        window.URL.revokeObjectURL(url)
        this.downloading = false
      })
    },
    // 点击上传按钮
    handleUpLoad(params) {
      this.uploading = true
      staff
        .uploadExcel('file', params.file)
        .then((res) => {
          this.uploading = false
          this.onLoad(this.page)
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('_default.toast.title'),
              icon: 'BellIcon',
              text: this.$t('_default.toast.text.success'),
              variant: 'success',
            },
          })
        })
        .catch((err) => {
          this.uploading = false
        })
    },
    handleDrawerClose() {
      this.drawerVisible = false
      this.onLoad(this.page)
    },
    refreshChange() {
      this.onLoad(this.page, this.query)
    },
    // 点击下载按钮
    rowDel(e) {
      staff
        .remove(e.id)
        .then(() => {
          this.onLoad(this.page)
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('_default.toast.title'),
              icon: 'BellIcon',
              text: this.$t('_default.toast.text.success'),
              variant: 'success',
            },
          })
        })
        .catch(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('_default.toast.title'),
              icon: 'BellIcon',
              text: this.$t('_default.toast.text.danger'),
              variant: 'danger',
            },
          })
        })
    },
    // 分页更改
    onPageChange(e) {
      console.log(e, 'onPageChange')
    },
    // 当前页改变
    pageChange(e) {
      this.page.currentPage = e
      this.onLoad(this.page)
    },
    // 页数据数量改变
    pageSizeChange(e) {
      this.page.pageSize = e
      this.onLoad(this.page)
    },
    getSelectedRows() {
      // 调用该方法可以获取复选框勾选数据
      const rows = this.$refs['gtable-crud'].getSelectedRows()
      console.log(rows)
    },
    handleFormOpen(key, row = {}) {
      let reKey = key
      if (key === 'view') {
        this.drawerDisabled = true
        reKey = 'edit'
      }
      if (key === 'edit') {
        this.drawerDisabled = false
      }

      this.rowDataId = row.id
      this.drawerVisible = true
      this.formVisibleType = `StaffForm${reKey}`
    },
    // i18n
    i18n(param) {
      return this.$t(`_staff.${param}`)
    },
    handleBeforeClose(done) {
      done()
      this.onLoad(this.page)
    },
    handleImgClick(e) {
      if (e) {
        this.currentImg = e
        this.dialogShow = true
      }
    },
    handleEditAccount(row) {
      getUser(row.userId).then((res) => {
        this.rowData = res.data.data
        this.accountDrawerShow = true
      })
    },
    handleResetPassword(row) {
      getUser(row.userId).then((res) => {
        this.rowData = res.data.data
        this.resetPasswordShow = true
      })
    },
    handleStaffQuit(row) {
      this.rowData = row
      this.staffQuitShow = true
    },
    handleStaffJoin(row) {
      this.rowData = row
      this.staffJoinShow = true
    },
    handleStaffConfirmation(row) {
      this.rowData = row
      this.staffConfirmationShow = true
    },
    async handleVcardLink(row) {
      if (!row.staffNo) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('_default.toast.title'),
            icon: 'BellIcon',
            text: this.$t('_components.message.noStaffNo'),
            variant: 'danger',
          },
        })
        return
      }
      try {
        this.vcardLink = await buildVcardLink(row.staffNo)
        this.vcardLinkShow = true
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('_default.toast.title'),
            icon: 'BellIcon',
            text: this.$t('_components.message.vcardLinkFail'),
            variant: 'danger',
          },
        })
      }
    },
    copyVcardLink() {
      const notify = (ok) => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('_default.toast.title'),
            icon: 'BellIcon',
            text: this.$t(ok ? '_components.message.copied' : '_components.message.copyFailed'),
            variant: ok ? 'success' : 'danger',
          },
        })
      }
      const box = this.$refs.vcardLinkText && this.$refs.vcardLinkText.parentNode
      if (!box || !this.vcardLink) {
        notify(false)
        return
      }
      const input = document.createElement('textarea')
      input.value = this.vcardLink
      input.setAttribute('readonly', 'readonly')
      input.style.position = 'fixed'
      input.style.top = '0'
      input.style.left = '0'
      input.style.width = '1px'
      input.style.height = '1px'
      input.style.opacity = '0'
      box.appendChild(input)
      input.focus()
      input.select()
      input.setSelectionRange(0, input.value.length)
      let ok = false
      try {
        ok = document.execCommand('copy')
      } catch (e) {
        ok = false
      }
      box.removeChild(input)
      notify(ok)
    },
    handleStaffQuitConfirm() {
      this.staffQuitShow = false
      staff.staffQuit({ staffId: this.rowData.id }).then((res) => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('_default.toast.title'),
            icon: 'BellIcon',
            text: this.$t('_default.toast.text.success'),
            variant: 'success',
          },
        })
        this.onLoad(this.page)
      })
    },
    handleStaffJoinConfirm() {
      this.staffJoinShow = false
      staff.staffJoin({ staffId: this.rowData.id }).then((res) => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('_default.toast.title'),
            icon: 'BellIcon',
            text: this.$t('_default.toast.text.success'),
            variant: 'success',
          },
        })
        this.onLoad(this.page)
      })
    },
    handleStaffConfirmationConfirm() {
      staff.staffConfirmation({ staffId: this.rowData.id }).then((res) => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('_default.toast.title'),
            icon: 'BellIcon',
            text: this.$t('_default.toast.text.success'),
            variant: 'success',
          },
        })
        this.staffConfirmationShow = false
        this.onLoad(this.page)
      })
    },
    handleResetPasswordConfirm() {
      resetPassword(this.rowData.id).then((res) => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('_default.toast.title'),
            icon: 'BellIcon',
            text: this.$t('_default.toast.text.success'),
            variant: 'success',
          },
        })
        this.resetPasswordShow = false
        this.onLoad(this.page)
      })
    },
    handleAccountEdit(done, form) {
      // console.log(form, 'form');
      accountUpdate(form).then(() => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('_default.toast.title'),
            icon: 'BellIcon',
            text: this.$t('_default.toast.text.success'),
            variant: 'success',
          },
        })
        this.accountDrawerShow = false
        this.onLoad(this.page)
        done()
      })
    },
    getDayNum(startTime, endTime) {
      const stTime = Date.parse(new Date(startTime))
      const etTime = Date.parse(new Date(endTime))
      const usedTime = etTime - stTime
      const days = Math.floor(usedTime / (24 * 3600 * 1000))
      return days
    },
    isExpiringDate(date) {
      if (date) {
        return this.getDayNum('2022-3-5', new Date()) < 7
      }
      return false
    },
  },
}
</script>
<style lang="scss" scoped>
.en-name-box {
  display: flex;
  align-items: center;
  p {
    margin: 0 0 0 5px;
    padding: 0;
  }
}
.red {
  color: red;
}
.vcard-link-box {
  word-break: break-all;
  p {
    margin-bottom: 16px;
    color: #2f6fed;
    user-select: text;
  }
}
</style>
